// Traductions de l'outil : window.PTX_T (texte français → traduction), écrit par le thème hors français.
var ptxT = window.ptxT || (window.ptxT = (s) => (window.PTX_T && window.PTX_T[s]) || s);
/*
 * Printtex : « Commande d'équipe » dans l'outil de personnalisation (onglet Tailles), en un seul parcours :
 *   1. Style : ce qu'on imprime au dos (nom + numéro, nom, numéro, ou rien), police, couleur, taille, position,
 *      aperçu en direct avec un exemple (« MARTIN 10 »). Le visuel de face (logo du club) reste commun.
 *   2. Liste : une ligne par personne (prénom / nom, numéro, taille, quantité), « Coller une liste »,
 *      récapitulatif par taille ; les quantités alimentent l'outil : prix dégressif sur toute l'équipe.
 *   3. Aperçu de tout le monde : une miniature par personne (dos avec son nom et son numéro), clic = agrandir,
 *      « Corriger » renvoie à sa ligne ; puis « Ajouter l'équipe au panier ».
 * Panier : UNE ligne pour toute l'équipe (variante « N pièces » = prix dégressif du total), récapitulatif lisible,
 * un PNG d'impression par personne et la liste détaillée en propriétés « _ » pour l'atelier.
 * Seul lien avec l'outil : window.PrinttexPerso (printtex-perso.js). Le modèle « Nom et numéro (dos) » de l'onglet
 * Idées ouvre ce mode (window.PrinttexEquipe.ouvrir, appelé par printtex-modeles.js).
 */
(() => {
  let P = null;
  const POLICES = ['Oswald', 'Bebas Neue', 'Anton', 'Teko', 'Staatliches', 'Russo One', 'Black Ops One', 'Archivo Black', 'Alfa Slab One', 'Bungee', 'Montserrat', 'Permanent Marker'];
  const TAILLES_TEXTE = { S: 0.45, M: 0.62, L: 0.8 }; // largeur du nom / numéro, en part de la zone du dos
  const etat = {
    actif: false,
    etape: 'style',
    style: { contenu: 'nom-numero', police: 'Oswald', couleur: 'auto', taille: 'M', position: 'haut', echNom: 1, echNum: 1 },
    lignes: [], // { nom, numero, taille, qte }
  };
  let racine = null;
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const $ = (s) => racine.querySelector(s);

  const tailles = () => (P.tailleIdx >= 0 ? P.data.options[P.tailleIdx].values : ['']);
  const sansTaille = () => P.tailleIdx < 0;
  const aDos = () => !P.data.sides || P.data.sides.includes('dos');
  // Jogging (P.data.jambes) : nom / numéro sur une jambe au choix, pas au dos ; côté = 'face' (jambe gauche) ou 'dos' (jambe droite).
  const JAMBES = () => !!P.data.jambes;
  const cote = () => (JAMBES() ? etat.style.jambe : 'dos');
  const surCote = () => (JAMBES() ? `${ptxT("sur la jambe (")}${P.SIDES[cote()].toLowerCase()})` : ptxT("au dos"));
  const avecNom = () => aDos() && etat.style.contenu.includes('nom');
  const avecNumero = () => aDos() && etat.style.contenu.includes('numero');
  const perso = () => avecNom() || avecNumero(); // quelque chose de différent par personne
  const vide = () => ({ nom: '', numero: '', taille: '', qte: 1 });

  /* ---------- Interface (dans le panneau Tailles) ---------- */
  function installer() {
    P = window.PrinttexPerso;
    if (!P || P.$('[data-peo]')) return;
    const panneau = P.$('[data-pp-panel="quantites"]');
    if (!panneau) return;
    // Couleur « auto » : la couleur du vêtement est connue un peu après l'ouverture (et change avec lui) ;
    // l'exemple est redessiné à ce moment (17/10/2026 : « MARTIN 10 » sombre sur un textile noir).
    P.ext?.couleur.push(() => { if (etat.actif && etat.style.couleur === 'auto' && etat.etape !== 'apercu' && groupeDos()) poserExemple(); });
    // Karim 23/10 (vidéo, 2:56) : toucher le nom / numéro d'exemple sur le vêtement ouvre la commande d'équipe à l'étape Style.
    P.ext?.selection?.push((o) => { if (!o || o.ppType !== 'equipe' || !etat.actif || !aDos()) return; P.setTab('quantites'); const b = P.$('[data-rail="quantites"]'); if (b && P.state.railOuvert !== 'quantites') b.click(); if (etat.etape !== 'style') allerA('style'); });
    if (!aDos()) etat.style.contenu = 'rien';
    if (JAMBES()) { etat.style.jambe = etat.style.jambe || 'face'; if (!['cuisse', 'jambe'].includes(etat.style.position)) etat.style.position = 'cuisse'; }
    racine = document.createElement('div');
    racine.className = 'peo';
    racine.dataset.peo = '';
    racine.innerHTML = `
      <button type="button" class="peo__ouvrir" data-peo-ouvrir aria-expanded="false">
        ${ptxT("Commande d'équipe")}
        <span>${ptxT("Club, entreprise, école : tailles")}${aDos() ? ptxT(", noms et numéros") : ''} ${ptxT("par personne")}</span>
      </button>
      <div class="peo__corps" data-peo-corps hidden>
        <ol class="peo__etapes" data-peo-etapes>
          ${aDos() ? `<li><button type="button" data-peo-aller="style">${ptxT("1. Style")}</button></li>` : ''}
          <li><button type="button" data-peo-aller="liste">${aDos() ? '2' : '1'}. Liste</button></li>
          ${aDos() ? `<li><button type="button" data-peo-aller="apercu">${ptxT("3. Aperçu")}</button></li>` : ''}
        </ol>

        ${aDos() ? `<section class="peo__etape" data-peo-etape="style" hidden>
          <p class="peo__titre">${JAMBES() ? ptxT("Sur une jambe de chaque jogging") : ptxT("Au dos de chaque vêtement")}</p>
          <div class="peo__seg" data-peo-choix="contenu">
            <button type="button" data-v="nom-numero">${ptxT("Nom + numéro")}</button>
            <button type="button" data-v="nom">${ptxT("Nom")}</button>
            <button type="button" data-v="numero">${ptxT("Numéro")}</button>
            <button type="button" data-v="rien">${ptxT("Rien")}</button>
          </div>
          <div class="peo__style" data-peo-style>
            <p class="peo__titre">${ptxT("Police")}</p>
            <div class="peo__polices" data-peo-choix="police">${POLICES.map((f) => `<button type="button" data-v="${f}" style="font-family:'${f}'">${f}</button>`).join('')}</div>
            <p class="peo__titre">${ptxT("Couleur du texte")}</p>
            <div class="peo__couleurs" data-peo-choix="couleur"><button type="button" class="peo__auto" data-v="auto">${ptxT("Auto")}</button>${P.COLORS.map((c) => `<button type="button" class="peo__pastille" data-v="${c}" style="background:${c}" aria-label="Couleur ${c}"></button>`).join('')}</div>
            <p class="peo__titre">Taille</p>
            <div class="peo__seg" data-peo-choix="taille"><button type="button" data-v="S">${ptxT("Petit")}</button><button type="button" data-v="M">${ptxT("Moyen")}</button><button type="button" data-v="L">${ptxT("Grand")}</button></div>
            <div class="peo__ech" data-peo-ech><span data-peo-ech-ligne="echNom">${ptxT("Nom")} <button type="button" data-peo-ech="echNom" data-d="-1" aria-label="${ptxT("Nom plus petit")}">−</button><b data-peo-ech-val="echNom">100 %</b><button type="button" data-peo-ech="echNom" data-d="1" aria-label="${ptxT("Nom plus grand")}">+</button></span><span data-peo-ech-ligne="echNum">${ptxT("Numéro")} <button type="button" data-peo-ech="echNum" data-d="-1" aria-label="${ptxT("Numéro plus petit")}">−</button><b data-peo-ech-val="echNum">100 %</b><button type="button" data-peo-ech="echNum" data-d="1" aria-label="${ptxT("Numéro plus grand")}">+</button></span></div>
            ${JAMBES() ? `<p class="peo__titre">${ptxT("Jambe")}</p>
            <div class="peo__seg" data-peo-choix="jambe"><button type="button" data-v="face">${P.SIDES.face}</button><button type="button" data-v="dos">${P.SIDES.dos}</button></div>
            <p class="peo__titre">${ptxT("Position")}</p>
            <div class="peo__seg" data-peo-choix="position"><button type="button" data-v="cuisse">${ptxT("Haut de cuisse")}</button><button type="button" data-v="jambe">${ptxT("Long de la jambe")}</button></div>` : `<p class="peo__titre">${ptxT("Position")}</p>
            <div class="peo__seg" data-peo-choix="position"><button type="button" data-v="haut">${ptxT("Haut du dos")} <small>${ptxT("(conseillé)")}</small></button><button type="button" data-v="centre">${ptxT("Centre du dos")}</button></div>`}
          </div>
          <p class="pp-note" data-peo-style-note></p>
          <button type="button" class="peo__suite" data-peo-aller="liste">${ptxT("Suivant : la liste")}</button>
        </section>` : ''}

        <section class="peo__etape" data-peo-etape="liste" hidden>
          <ol class="peo__liste" data-peo-liste></ol>
          <div class="peo__actions">
            <button type="button" class="pp-btn" data-peo-ajouter>${ptxT("+ Ajouter une personne")}</button>
            <button type="button" class="pp-btn" data-peo-coller-ouvrir>${ptxT("Coller une liste")}</button>
            <button type="button" class="pp-btn" data-peo-lien>${ptxT("Lien pour l'équipe")}</button>
          </div>
          <div class="peo__collecte" data-peo-collecte hidden></div>
          <textarea class="peo__coller" data-peo-coller hidden rows="4" placeholder="${ptxT("Une personne par ligne, par exemple :&#10;Martin ; 10 ; M&#10;Léa ; 7 ; S&#10;L ; 3 (taille ; quantité)")}"></textarea>
          <p class="peo__recap" data-peo-recap aria-live="polite"></p>
          <p class="pp-note">${ptxT("Le prix dégressif s'applique à la quantité totale de l'équipe. Une seule ligne au panier pour toute l'équipe.")}</p>
          ${aDos() ? `<button type="button" class="peo__suite" data-peo-aller="apercu">${ptxT("Suivant : voir tout le monde")}</button>` : ''}
        </section>

        ${aDos() ? `<section class="peo__etape" data-peo-etape="apercu" hidden>
          <p class="peo__relire">${ptxT("Relisez bien chaque nom : ils seront imprimés tels quels (accents, majuscules, orthographe).")}</p>
          <p class="pp-note" data-peo-apercu-etat></p>
          <ul class="peo__grille" data-peo-grille></ul>
          <p class="peo__recap-final" data-peo-recap-final></p>
          <button type="button" class="peo__suite peo__suite--panier" data-peo-panier>${ptxT("Ajouter l'équipe au panier")}</button>
        </section>` : ''}

        <p class="peo__erreur" data-peo-erreur hidden></p>
        <button type="button" class="peo__quitter" data-peo-quitter>${ptxT("Revenir aux tailles simples")}</button>
      </div>`;
    panneau.appendChild(racine); // fermé : sous les tailles, sur une ligne (remonte en haut une fois ouvert)

    $('[data-peo-ouvrir]').addEventListener('click', () => (etat.actif ? quitter() : activer()));
    $('[data-peo-quitter]').addEventListener('click', quitter);
    racine.addEventListener('click', (e) => {
      const aller = e.target.closest('[data-peo-aller]');
      if (aller) { allerA(aller.dataset.peoAller); return; }
      const choix = e.target.closest('[data-peo-choix] [data-v]');
      if (choix) { choisir(choix.closest('[data-peo-choix]').dataset.peoChoix, choix.dataset.v); }
      const ech = e.target.closest('[data-peo-ech]');
      if (ech) {
        const k = ech.dataset.peoEch;
        etat.style[k] = Math.round(Math.min(1.6, Math.max(0.6, (etat.style[k] || 1) + 0.1 * Number(ech.dataset.d))) * 10) / 10;
        majChoix();
        poserExemple();
      }
    });
    $('[data-peo-ajouter]').addEventListener('click', () => { etat.lignes.push(vide()); dessinerListe(); racine.querySelector('.peo__ligne:last-child input')?.focus(); });
    $('[data-peo-coller-ouvrir]').addEventListener('click', () => { const t = $('[data-peo-coller]'); t.hidden = !t.hidden; if (!t.hidden) t.focus(); });
    $('[data-peo-coller]').addEventListener('change', coller);
    $('[data-peo-lien]').addEventListener('click', creerLien);
    $('[data-peo-collecte]').addEventListener('click', (e) => {
      if (e.target.closest('[data-peo-recuperer]')) recuperer();
      if (e.target.closest('[data-peo-copier]')) navigator.clipboard?.writeText(collecte().lien).then(() => { e.target.textContent = ptxT("Lien copié"); });
      if (e.target.closest('[data-peo-partager]')) navigator.share?.({ title: ptxT("Commande d'équipe"), text: ptxT("Indiquez vos informations pour la commande :"), url: collecte().lien }).catch(() => {});
    });
    majCollecte();
    $('[data-peo-liste]').addEventListener('input', lireLignes);
    // La personne en cours de saisie s'affiche sur le vêtement (aperçu réel de sa ligne).
    const montrerLigne = (e) => {
      const li = e.target.closest('.peo__ligne'); if (!li || !perso()) return;
      const l = etat.lignes[[...li.parentNode.children].indexOf(li)];
      if (l && ((avecNom() && l.nom.trim()) || (avecNumero() && l.numero))) appliquer({ ...l, nom: l.nom || '' });
    };
    $('[data-peo-liste]').addEventListener('focusin', montrerLigne);
    $('[data-peo-liste]').addEventListener('input', montrerLigne);
    // Entrée : ligne suivante (créée si c'était la dernière), curseur sur son premier champ.
    $('[data-peo-liste]').addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' || !e.target.matches('input')) return;
      e.preventDefault();
      const li = e.target.closest('.peo__ligne'); const i = [...li.parentNode.children].indexOf(li);
      if (i === etat.lignes.length - 1) { lireLignes(); etat.lignes.push(vide()); dessinerListe(); }
      racine.querySelectorAll('.peo__ligne')[i + 1]?.querySelector('input')?.focus();
    });
    $('[data-peo-liste]').addEventListener('change', lireLignes);
    $('[data-peo-liste]').addEventListener('click', (e) => {
      const li = e.target.closest('.peo__ligne');
      if (li && e.target.closest('[data-peo-suppr]')) { etat.lignes.splice([...li.parentNode.children].indexOf(li), 1); dessinerListe(); }
    });
    $('[data-peo-grille]')?.addEventListener('click', (e) => {
      const carte = e.target.closest('[data-peo-i]');
      if (!carte) return;
      const i = +carte.dataset.peoI;
      if (e.target.closest('[data-peo-corriger]')) { allerA('liste'); racine.querySelectorAll('.peo__ligne')[i]?.querySelector('input')?.focus(); return; }
      const img = carte.querySelector('img');
      if (img?.src) agrandir(img.src, carte.querySelector('figcaption')?.textContent || '');
    });
    $('[data-peo-panier]')?.addEventListener('click', ajouterEquipe);

    // Bouton « Ajouter au panier » de l'outil : en mode équipe, c'est l'équipe entière qui part au panier.
    P.$('[data-pp-add]')?.addEventListener('click', (e) => {
      if (!etat.actif) return;
      e.stopImmediatePropagation();
      e.preventDefault();
      ajouterEquipe();
    }, true);
    majChoix();
  }

  function activer() {
    etat.actif = true;
    racine.parentElement?.insertBefore(racine, racine.parentElement.firstChild);
    $('[data-peo-corps]').hidden = false;
    $('[data-peo-ouvrir]').setAttribute('aria-expanded', 'true');
    racine.classList.add('is-actif');
    P.$('[data-pp-sizes]').hidden = true;
    // 3 lignes vides : les quantités de l'onglet Tailles ne sont pas reprises (sinon une ligne sans personne compte).
    if (!etat.lignes.length) while (etat.lignes.length < 3) etat.lignes.push(vide());
    // Jogging : un seul marquage par jambe → l'équipe va par défaut sur la jambe sans visuel.
    if (JAMBES()) {
      const occupe = (k) => P.state.canvases[k]?.getObjects().some((o) => o.ppType !== 'equipe');
      const autre = etat.style.jambe === 'face' ? 'dos' : 'face';
      if (occupe(etat.style.jambe) && !occupe(autre)) etat.style.jambe = autre;
      majChoix();
    }
    dessinerListe();
    allerA(aDos() ? 'style' : 'liste');
  }

  async function quitter() {
    etat.actif = false;
    racine.parentElement?.appendChild(racine);
    $('[data-peo-corps]').hidden = true;
    $('[data-peo-ouvrir]').setAttribute('aria-expanded', 'false');
    racine.classList.remove('is-actif');
    P.$('[data-pp-sizes]').hidden = false;
    // L'exemple du dos ne doit pas partir dans une commande normale.
    if (groupeDos()) { retirerGroupe(); P.snapshot(); P.updatePrice(); }
    synchroniser();
  }

  function allerA(etape) {
    if (!racine.querySelector(`[data-peo-etape="${etape}"]`)) etape = 'liste';
    etat.etape = etape;
    racine.querySelectorAll('[data-peo-etape]').forEach((s) => { s.hidden = s.dataset.peoEtape !== etape; });
    racine.querySelectorAll('[data-peo-etapes] [data-peo-aller]').forEach((b) => b.classList.toggle('is-on', b.dataset.peoAller === etape));
    erreur('');
    if (etape === 'style') { P.setSide(cote()); poserExemple(); }
    if (etape === 'liste') dessinerListe();
    if (etape === 'apercu') apercuTous();
  }

  /* ---------- Étape 1 : style du dos ---------- */
  function choisir(cle, v) {
    if (cle === 'jambe' && v !== etat.style.jambe) { retirerGroupe(); etat.style.jambe = v; P.setSide(v); }
    etat.style[cle] = v;
    majChoix();
    if (cle === 'police') document.fonts?.load(`bold 40px "${v}"`).then(() => poserExemple()).catch(() => poserExemple());
    else poserExemple();
  }

  function majChoix() {
    racine.querySelectorAll('[data-peo-ech-val]').forEach((b) => { b.textContent = `${Math.round((etat.style[b.dataset.peoEchVal] || 1) * 100)} %`; });
    racine.querySelector('[data-peo-ech-ligne="echNom"]')?.toggleAttribute('hidden', !avecNom());
    racine.querySelector('[data-peo-ech-ligne="echNum"]')?.toggleAttribute('hidden', !avecNumero() || (JAMBES() && etat.style.position === 'jambe'));
    racine.querySelectorAll('[data-peo-choix]').forEach((g) => {
      const v = etat.style[g.dataset.peoChoix];
      g.querySelectorAll('[data-v]').forEach((b) => { b.classList.toggle('is-on', b.dataset.v === v); b.setAttribute('aria-pressed', b.dataset.v === v); });
    });
    const st = $('[data-peo-style]');
    if (st) st.hidden = !perso();
    const note = $('[data-peo-style-note]');
    if (note) {
      note.textContent = perso()
        ? `${ptxT("Aperçu")} ${surCote()} ${ptxT("avec un exemple («")} ${exemple().nom ? exemple().nom.toLocaleUpperCase('fr-FR') : ''}${avecNom() && avecNumero() ? ' ' : ''}${avecNumero() ? exemple().numero : ''} »). ${JAMBES() ? ptxT("Le reste du visuel") : ptxT("Le visuel de face")} ${ptxT("reste le même pour tous.")}`
        : ptxT("Même visuel pour toute l'équipe : seules les tailles changent.");
      if (JAMBES() && perso() && P.state.canvases[cote()]?.getObjects().some((o) => o.ppType !== 'equipe')) {
        note.textContent += ` ${ptxT("Attention : votre visuel est déjà sur la")} ${P.SIDES[cote()].toLowerCase()} ${ptxT("; un seul marquage par jambe, choisissez l'autre jambe.")}`;
      }
    }
  }

  const couleurTexte = () => (etat.style.couleur === 'auto' ? (P.state.fonce ? '#ffffff' : '#111111') : etat.style.couleur);
  const exemple = () => {
    const l = etat.lignes.find((x) => (avecNom() && x.nom.trim()) || (avecNumero() && x.numero));
    return { nom: avecNom() ? (l?.nom.trim() || ptxT("Martin")) : '', numero: avecNumero() ? (l?.numero || '10') : '' };
  };
  const groupeDos = () => Object.values(P.state.canvases).flatMap((c) => c.getObjects()).find((o) => o.ppType === 'equipe');

  // Nom (au-dessus) + numéro, dans le style choisi, placé dans la zone du dos.
  function construireGroupe(v, reference = false) {
    const s = etat.style;
    const eN = reference ? 1 : (s.echNom || 1); const eU = reference ? 1 : (s.echNum || 1);
    const fill = couleurTexte();
    const objs = [];
    if (JAMBES() && s.position === 'jambe') {
      // Long de la jambe : nom et numéro sur une seule ligne, lue le long de la jambe.
      const ligne = [avecNom() ? v.nom.trim().toLocaleUpperCase('fr-FR') : '', avecNumero() ? String(v.numero || '') : ''].filter(Boolean).join('  ');
      if (ligne) objs.push(new fabric.Text(ligne, { fontFamily: s.police, fontWeight: 'bold', fontSize: 120 * eN, charSpacing: 80, fill, originX: 'center', originY: 'top', left: 0, top: 0 }));
    } else if (avecNom() && v.nom.trim()) {
      objs.push(new fabric.Text(v.nom.trim().toLocaleUpperCase('fr-FR'), { fontFamily: s.police, fontWeight: 'bold', fontSize: 56 * eN, charSpacing: 120, fill, originX: 'center', originY: 'top', left: 0, top: 0 }));
    }
    if (avecNumero() && v.numero && !(JAMBES() && s.position === 'jambe')) {
      const top = objs.length ? objs[0].height + 4 : 0;
      objs.push(new fabric.Text(String(v.numero), { fontFamily: s.police, fontWeight: 'bold', fontSize: (avecNom() ? 220 : 240) * eU, fill, originX: 'center', originY: 'top', left: 0, top }));
    }
    if (!objs.length) return null;
    const g = new fabric.Group(objs, { originX: 'center', originY: 'center', selectable: true, evented: true, hasControls: false, lockMovementX: true, lockMovementY: true, lockRotation: true, lockScalingX: true, lockScalingY: true, hoverCursor: 'pointer' }); // Karim 23/10 : toucher « MARTIN 10 » ouvre le style
    g.ppType = 'equipe';
    g.ppProps = { style: { ...s }, valeurs: { nom: v.nom, numero: v.numero } };
    if (reference) return g;
    const W = P.LOGICAL_W; const H = P.logicalH(cote());
    // Échelle calculée sur le bloc à 100 % (nom et numéro à leur taille normale), puis bornée pour rester dans la zone.
    const ref = (s.echNom || 1) === 1 && (s.echNum || 1) === 1 ? g : construireGroupe(v, true);
    const borne = (k, angle) => Math.min(k, angle ? (H * 0.95) / g.width : (W * 0.95) / g.width, angle ? (W * 0.95) / g.height : (H * 0.9) / g.height);
    if (JAMBES()) {
      // Haut de cuisse : à plat, 10 cm max ; long de la jambe : le nom se lit le long de la jambe (tourné), jusqu'à toute la zone.
      // Calé en haut de la zone et centré sur la jambe, comme les positions fixes de l'outil.
      const u = W / P.zoneOf(cote()).cmW;
      if (s.position === 'jambe') {
        const kj = borne(Math.min((H * 0.95 * TAILLES_TEXTE[s.taille]) / ref.width, (W * 0.95) / ref.height), true);
        g.set({ angle: -90, scaleX: kj, scaleY: kj, left: W / 2, top: (g.width * kj) / 2 });
      } else {
        const kc = borne(Math.min((Math.min(10 * u, W) * TAILLES_TEXTE[s.taille]) / ref.width, (10 * u) / ref.height), false);
        g.set({ scaleX: kc, scaleY: kc, left: W / 2, top: (g.height * kc) / 2 });
      }
      return g;
    }
    const k = borne(Math.min((W * TAILLES_TEXTE[s.taille]) / ref.width, (H * 0.75) / ref.height), false);
    const h = g.height * k;
    g.set({ scaleX: k, scaleY: k, left: W / 2, top: s.position === 'haut' ? Math.min(H * 0.07 + h / 2, H / 2) : H * 0.45 });
    return g;
  }

  function retirerGroupe() {
    const avant = P.state.restoring;
    P.state.restoring = true;
    // Le texte d'équipe (sur tous les côtés : la jambe a pu changer), et l'ancien modèle « Nom et numéro » de l'onglet Idées.
    Object.values(P.state.canvases).forEach((c) => c.getObjects().filter((o) => o.ppType === 'equipe' || (o.ppType === 'modele' && o.ppProps?.id === 'sport-dos')).forEach((o) => c.remove(o)));
    P.state.restoring = avant;
  }

  // Remplace le texte du dos par celui d'une personne (aucun point d'historique).
  function appliquer(v) {
    const c = P.state.canvases[cote()];
    if (!c) return null;
    // Police pas encore chargée : fabric mesurerait les lettres avec la police de secours (espacement irrégulier,
    // « KA RIM ») ; on redessine une fois la police prête, avec son cache de mesures vidé.
    const police = etat.style.police;
    if (document.fonts && !document.fonts.check(`bold 56px "${police}"`)) {
      document.fonts.load(`bold 56px "${police}"`).then(() => {
        fabric.util.clearFabricFontCache(police);
        if (etat.style.police === police && etat.etape !== 'apercu' && groupeDos()) appliquer(v);
      }).catch(() => {});
    }
    retirerGroupe();
    const g = construireGroupe(v);
    if (!g) { c.requestRenderAll(); return null; }
    const avant = P.state.restoring;
    P.state.restoring = true;
    if (JAMBES()) P.state.pos[cote()] = etat.style.position; // position fixe connue de l'outil
    c.add(g);
    P.fitInZone?.(g);
    P.state.restoring = avant;
    c.requestRenderAll();
    return g;
  }

  let histo;
  function poserExemple() {
    if (!P.state.canvases[cote()]) return;
    appliquer(exemple());
    majChoix();
    P.updatePrice();
    clearTimeout(histo);
    histo = setTimeout(() => P.snapshot(), 500); // création gardée sur l'appareil avec le style choisi
  }

  /* ---------- Étape 2 : liste ---------- */
  function dessinerListe() {
    const options = tailles().map((t) => {
      const v = P.variantFor(P.state.variant ? P.couleurOf(P.state.variant) : '', t);
      return `<option value="${esc(t)}"${v && !v.available ? ' disabled' : ''}>${esc(t || ptxT("Unique"))}</option>`;
    }).join('');
    const cols = ['22px', 'minmax(0,1fr)'];
    if (avecNumero()) cols.push('52px');
    if (!sansTaille()) cols.push('74px');
    if (!perso()) cols.push('56px');
    cols.push('32px');
    const liste = $('[data-peo-liste]');
    liste.style.setProperty('--peo-cols', cols.join(' '));
    liste.innerHTML = etat.lignes.map((l, i) => `
      <li class="peo__ligne">
        <span class="peo__num">${i + 1}.</span>
        <input type="text" placeholder="${ptxT("Prénom / nom")}${avecNom() ? (JAMBES() ? ` ${ptxT("(sur la jambe)")}` : ` ${ptxT("(au dos)")}`) : ` ${ptxT("(facultatif)")}`}" value="${esc(l.nom)}" data-peo-champ="nom" aria-label="${ptxT("Nom")}" maxlength="20">
        ${avecNumero() ? `<input type="text" inputmode="numeric" placeholder="N°" value="${esc(l.numero)}" data-peo-champ="numero" aria-label="${ptxT("Numéro")}" maxlength="3">` : ''}
        ${sansTaille() ? '' : `<select data-peo-champ="taille" aria-label="${ptxT("Taille")}"><option value="">${ptxT("Taille")}</option>${options}</select>`}
        ${perso() ? '' : `<input type="number" min="1" max="200" inputmode="numeric" value="${l.qte || 1}" data-peo-champ="qte" aria-label="${ptxT("Quantité")}">`}
        <button type="button" class="peo__suppr" data-peo-suppr aria-label="${ptxT("Retirer")}">×</button>
      </li>`).join('');
    liste.querySelectorAll('.peo__ligne').forEach((li, i) => {
      const s = li.querySelector('[data-peo-champ="taille"]');
      if (s) s.value = etat.lignes[i].taille || '';
    });
    synchroniser();
  }

  function lireLignes() {
    racine.querySelectorAll('.peo__ligne').forEach((li, i) => {
      const l = etat.lignes[i];
      li.querySelectorAll('[data-peo-champ]').forEach((c) => {
        const k = c.dataset.peoChamp;
        l[k] = k === 'qte' ? Math.max(1, Math.min(200, parseInt(c.value, 10) || 1)) : k === 'numero' ? c.value.replace(/\D/g, '').slice(0, 3) : c.value;
      });
    });
    synchroniser();
  }

  // Lignes comptées : une taille (ou produit sans taille) et, si on imprime nom / numéro, un nom ou un numéro.
  const valides = () => etat.lignes
    .filter((l) => (sansTaille() || l.taille) && (!perso() || (avecNom() && l.nom.trim()) || (avecNumero() && l.numero)))
    .map((l) => ({ ...l, nom: l.nom.trim(), qte: perso() ? 1 : (l.qte || 1) }));

  function synchroniser() {
    const ok = valides();
    const qty = {};
    ok.forEach((l) => { qty[l.taille] = (qty[l.taille] || 0) + l.qte; });
    if (etat.actif) {
      Object.keys(P.state.qty).forEach((t) => { P.state.qty[t] = 0; });
      Object.assign(P.state.qty, qty);
      P.$$('[data-pp-sizes] .pp-size').forEach((cell) => {
        const t = cell.querySelector('span')?.textContent;
        const input = cell.querySelector('input');
        if (input) input.value = qty[t === 'Quantité' ? '' : t] || '';
      });
      P.updatePrice();
    }
    const total = ok.reduce((a, l) => a + l.qte, 0);
    const recap = tailles().filter((t) => qty[t]).map((t) => (t ? `${t} × ${qty[t]}` : `${qty[t]}`)).join(', ');
    $('[data-peo-recap]').textContent = total ? `${total} ${ptxT("pièce")}${total > 1 ? 's' : ''}${recap && !sansTaille() ? ` : ${recap}` : ''}` : '';
    // Au-delà du maximum en ligne : sur devis, avec la liste de l'équipe reprise dans le formulaire de devis.
    const max = P.data.tarifs?.max_quantite || 100;
    const devis = total > max;
    const panier = $('[data-peo-panier]');
    if (panier) panier.disabled = devis;
    let lienDevis = $('[data-peo-devis]');
    if (devis) {
      const liste = ok.map((l) => [l.nom, l.numero, l.taille, perso() ? '' : `× ${l.qte}`].filter(Boolean).join(' ; ')).join('\n');
      try { localStorage.setItem('pp-devis-equipe', JSON.stringify({ produit: P.data.title, quantite: total, recap, liste })); } catch (e) { /* stockage indisponible */ }
      if (!lienDevis) { $('[data-peo-recap]').insertAdjacentHTML('afterend', '<a class="peo__devis" data-peo-devis></a>'); lienDevis = $('[data-peo-devis]'); }
      lienDevis.href = `/pages/devis?type=pro&equipe=1&produit=${encodeURIComponent(P.data.title)}&quantite=${total}`;
      lienDevis.textContent = `${ptxT("Plus de")} ${max} ${ptxT("pièces : recevoir un devis avec votre liste (sous 24 h)")}`;
    } else lienDevis?.remove();
  }

  function lireTaille(t) {
    const s = String(t).trim().toUpperCase().replace(/^2XL$/, 'XXL').replace(/^XXXL$/, '3XL');
    return tailles().find((x) => x.toUpperCase() === s) || '';
  }

  function coller() {
    const t = $('[data-peo-coller]');
    const lignes = t.value.split(/\r?\n/).map((l) => l.trim()).filter(Boolean);
    if (!lignes.length) return;
    etat.lignes = etat.lignes.filter((l) => l.nom || l.numero || l.taille);
    for (const l of lignes) {
      const m = l.split(/\s*[;,\t]\s*|\s+-\s+/).filter(Boolean);
      const p = vide();
      const nombres = [];
      for (const x of m) {
        const taille = lireTaille(x);
        if (taille && !p.taille) p.taille = taille;
        else if (/^\d{1,3}$/.test(x)) nombres.push(x);
        else if (!p.nom) p.nom = x.slice(0, 20);
      }
      // « Martin ; 10 ; M » : avec un nom, le nombre est le numéro ; un 2e nombre est la quantité.
      // Sans nom (« L ; 3 ») : quantité, ou numéro si l'on imprime des numéros seuls.
      if (p.nom || (avecNumero() && !avecNom())) { p.numero = nombres[0] || ''; if (nombres[1]) p.qte = Math.min(200, +nombres[1]); }
      else if (nombres[0]) p.qte = Math.min(200, +nombres[0]);
      etat.lignes.push(p);
    }
    t.value = '';
    t.hidden = true;
    dessinerListe();
  }

  /* ---------- Lien pour l'équipe (idée métier 1, 17/10/2026) ----------
     Chaque membre saisit son nom, son numéro et sa taille sur une page Printtex (Worker « printtex-equipe »,
     cloudflare/equipe) ; le responsable récupère les réponses ici. Lien gardé sur l'appareil (par produit), 90 jours. */
  const API_EQUIPE = 'https://printtex-equipe.printtex75.workers.dev';
  const cleCollecte = () => `pp-collecte-${P.data.handle}`;
  const collecte = () => { try { return JSON.parse(localStorage.getItem(cleCollecte()) || 'null'); } catch (e) { return null; } };
  function majCollecte(info = '') {
    const c = collecte(); const boite = $('[data-peo-collecte]');
    if (!boite) return;
    boite.hidden = !c && !info;
    $('[data-peo-lien]').hidden = !!c;
    const quoi = [avecNom() && ptxT("son nom"), avecNumero() && ptxT("son numéro"), !sansTaille() && ptxT("sa taille")].filter(Boolean).join(', ') || ptxT("sa taille");
    boite.innerHTML = c ? `<p class="peo__collecte-titre">${ptxT("Lien à envoyer à l'équipe (WhatsApp, e-mail…) : chacun indique")} ${quoi}.</p>
      <input class="peo__collecte-lien" readonly value="${esc(c.lien)}" onclick="this.select()">
      <div class="peo__actions"><button type="button" class="pp-btn" data-peo-copier>${ptxT("Copier le lien")}</button>${navigator.share ? `<button type="button" class="pp-btn" data-peo-partager>${ptxT("Partager")}</button>` : ''}<button type="button" class="pp-btn" data-peo-recuperer>${ptxT("Récupérer les réponses")}</button></div>
      <p class="pp-note">${esc(info)}</p>` : `<p class="pp-note">${esc(info)}</p>`;
  }
  async function creerLien() {
    const b = $('[data-peo-lien]'); b.disabled = true; b.textContent = ptxT("Création du lien…");
    try {
      const v = P.state.variant;
      const image = v?.image ? (String(v.image).startsWith('//') ? 'https:' + v.image : String(v.image)) : '';
      const r = await fetch(`${API_EQUIPE}/api/collecte`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
        produit: P.data.handle, titre: P.data.title, image, tailles: sansTaille() ? [] : tailles(), nom: avecNom(), numero: avecNumero(),
      }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.erreur || ptxT("Création impossible."));
      try { localStorage.setItem(cleCollecte(), JSON.stringify({ id: j.id, cle: j.cle, lien: j.lien })); } catch (e) { /* stockage indisponible */ }
      majCollecte(collecte() ? '' : `${ptxT("Lien :")} ${j.lien} ${ptxT("(notez-le : il ne sera pas gardé sur cet appareil)")}`);
    } catch (e) { majCollecte(`${ptxT("Lien non créé :")} ${e.message}`); }
    b.disabled = false; b.textContent = ptxT("Lien pour l'équipe");
  }
  async function recuperer() {
    const c = collecte(); if (!c) return;
    try {
      const r = await fetch(`${API_EQUIPE}/api/collecte/${c.id}?cle=${c.cle}`);
      const j = await r.json();
      if (!r.ok) throw new Error(j.erreur || ptxT("Lecture impossible."));
      const cle = (l) => [l.nom.trim().toLowerCase(), l.numero, l.taille].join('|');
      etat.lignes = etat.lignes.filter((l) => l.nom || l.numero || l.taille);
      const deja = new Set(etat.lignes.map(cle));
      let n = 0;
      for (const m of j.membres) {
        const l = { nom: (m.nom || '').slice(0, 20), numero: m.numero || '', taille: lireTaille(m.taille) || '', qte: 1 };
        if (deja.has(cle(l))) continue;
        deja.add(cle(l)); etat.lignes.push(l); n++;
      }
      dessinerListe();
      const t = j.membres.length; const s = (k) => (k > 1 ? 's' : '');
      majCollecte(`${t} ${ptxT("réponse")}${s(t)} ${ptxT("reçue")}${s(t)}, ${n} ${ptxT("ajoutée")}${s(n)} ${ptxT("à la liste. Vérifiez les noms avant de commander.")}`);
    } catch (e) { majCollecte(`${ptxT("Réponses non récupérées :")} ${e.message}`); }
  }

  /* ---------- Étape 3 : aperçu de tout le monde ---------- */
  const cache = new Map(); // clé (style + personne) → URL de la miniature
  let tour = 0;
  async function apercuTous() {
    const grille = $('[data-peo-grille]');
    const info = $('[data-peo-apercu-etat]');
    const ok = valides();
    const n = ++tour;
    if (!ok.length) { grille.innerHTML = ''; info.textContent = ptxT("Ajoutez au moins une personne (taille") + (perso() ? ptxT(", nom ou numéro") : '') + ptxT(") dans la liste."); return; }
    P.setSide(cote());
    grille.innerHTML = ok.map((l, i) => `<li data-peo-i="${etat.lignes.indexOf(etat.lignes.find((x) => x.nom.trim() === l.nom && x.numero === l.numero && x.taille === l.taille))}">
        <figure><span class="peo__vignette" data-peo-vignette="${i}"></span>
        <figcaption>${esc([l.nom, l.numero && `n° ${l.numero}`, l.taille, !perso() && l.qte > 1 ? `× ${l.qte}` : ''].filter(Boolean).join(', '))}</figcaption></figure>
        <button type="button" class="peo__corriger" data-peo-corriger>${ptxT("Corriger")}</button></li>`).join('');
    const liste = perso() ? ok : ok.slice(0, 1); // même visuel pour tous : une seule miniature suffit
    const pieces = `${ok.reduce((a, l) => a + l.qte, 0)} ${ptxT("pièce(s). Cliquez sur une miniature pour l'agrandir ; « Corriger » renvoie à la ligne.")}`;
    // Récapitulatif clair avant le panier : pièces par taille et prix total (celui de l'outil).
    const parT = {}; ok.forEach((l) => { parT[l.taille] = (parT[l.taille] || 0) + l.qte; });
    const totalP = ok.reduce((a, l) => a + l.qte, 0);
    const prixTotal = P.$('[data-pp-price]')?.dataset.total || '';
    const rf = $('[data-peo-recap-final]');
    if (rf) rf.innerHTML = `<strong>${totalP} ${ptxT("pièce")}${totalP > 1 ? 's' : ''}</strong>${sansTaille() ? '' : ' : ' + tailles().filter((t) => parT[t]).map((t) => `${t} × ${parT[t]}`).join(', ')}${prixTotal ? `, <strong>${prixTotal}</strong> ${ptxT("au total")}` : ''}`;
    info.textContent = pieces;
    /* Grandes équipes (17/10/2026 : 120 personnes = page qui rame) : une miniature n'est préparée que lorsqu'elle
       arrive à l'écran (ou presque), une à la fois, en rendant la main au navigateur entre deux. */
    const file = []; let occupe = false;
    const rendre = async (i) => {
      const cle = JSON.stringify([etat.style, liste[i].nom, liste[i].numero, P.state.variant?.id]);
      let url = cache.get(cle);
      if (!url) {
        await document.fonts?.load(`bold 56px "${etat.style.police}"`).catch(() => {});
        appliquer(liste[i]);
        url = URL.createObjectURL(await P.previewFile(cote()));
        cache.set(cle, url);
      }
      const cases = perso() ? [grille.querySelector(`[data-peo-vignette="${i}"]`)] : [...grille.querySelectorAll('[data-peo-vignette]')];
      cases.forEach((c) => { if (c) c.innerHTML = `<img src="${url}" alt="${ptxT("Aperçu")} ${surCote()}">`; });
    };
    const traiter = async () => {
      if (occupe) return;
      occupe = true;
      while (file.length && n === tour) {
        await rendre(file.shift());
        await new Promise((r) => setTimeout(r, 0));
      }
      occupe = false;
      if (n === tour) appliquer(exemple());
    };
    if (vuesObs) vuesObs.disconnect();
    vuesObs = new IntersectionObserver((entrees) => {
      entrees.forEach((e) => { if (e.isIntersecting) { vuesObs.unobserve(e.target); file.push(+e.target.dataset.peoVignette); } });
      traiter();
    }, { rootMargin: '300px 0px' });
    (perso() ? [...grille.querySelectorAll('[data-peo-vignette]')] : [grille.querySelector('[data-peo-vignette="0"]')]).forEach((c) => c && vuesObs.observe(c));
  }
  let vuesObs = null;

  function agrandir(src, legende) {
    const fond = document.createElement('div');
    fond.className = 'peo-zoom';
    fond.innerHTML = `<figure><img src="${src}" alt="${ptxT("Aperçu agrandi")}"><figcaption>${esc(legende)}</figcaption></figure>`;
    fond.addEventListener('click', () => fond.remove());
    document.body.appendChild(fond);
  }

  function erreur(msg) {
    const e = $('[data-peo-erreur]');
    e.textContent = msg;
    e.hidden = !msg;
  }

  /* ---------- Ajout au panier : toute l'équipe en une ligne ---------- */
  let enCours = false;
  async function ajouterEquipe() {
    if (enCours) return;
    erreur('');
    const add = P.$('[data-pp-add]');
    const ok = valides();
    if (!ok.length) { allerA('liste'); erreur(sansTaille() ? ptxT("Ajoutez au moins une personne.") : `${ptxT("Indiquez la taille")}${perso() ? ` ${ptxT("et le nom ou le numéro")}` : ''} ${ptxT("de chaque personne.")}`); return; }
    if (perso()) appliquer(ok[0]);
    const sides = P.usedSides();
    if (!sides.length) { erreur(ptxT("Ajoutez une image ou un texte sur le produit avant de commander.")); return; }
    const qty = ok.reduce((a, l) => a + l.qte, 0);
    const commande = await P.packCommande(sides.length, qty);
    if (!commande) { erreur(qty > 200 ? ptxT("Au-delà de 200 pièces, demandez un devis.") : ptxT("Tarif introuvable : appelez-nous au 01 86 04 31 65.")); return; }
    enCours = true;
    add.disabled = true;
    const btn = $('[data-peo-panier]');
    const libelle = add.textContent;
    const ecrire = (t) => { add.textContent = t; if (btn) btn.textContent = t; };
    ecrire(ptxT("Préparation…"));
    try {
      const ref = `E${Date.now().toString(36).toUpperCase()}`;
      const couleur = P.couleurIdx >= 0 ? P.couleurOf(P.state.variant) : '';
      const slug = P.slug;
      const props = [];
      const emplacements = []; // ligne lisible au panier : « Dos : nom et numéro, haut du dos, Face : 24,5 × 20 cm, centré »
      const POS = { haut: ptxT("haut du dos"), centre: ptxT("centre du dos"), cuisse: ptxT("haut de cuisse"), jambe: ptxT("long de la jambe") };
      for (const s of sides) {
        const Z = P.SIDES[s];
        if (s === cote() && perso()) {
          emplacements.push(`${Z} : ${[avecNom() && 'nom', avecNumero() && ptxT("numéro")].filter(Boolean).join(' et ')}, ${POS[etat.style.position] || etat.style.position}`);
          // Un PNG par personne : « nom_numéro_taille ».
          appliquer(ok[0]);
          props.push([`_${Z}${ptxT(", aperçu")}`, await P.previewFile(s), `apercu_${ref}_${slug(Z).toLowerCase()}.jpg`]);
          if (JAMBES() && P.consigneAtelier) { const ca = P.consigneAtelier(s, await P.printFile(s)); if (ca) props.push([`_${Z}${ptxT(", position")}`, ca.texte]); }
          for (let i = 0; i < ok.length; i++) {
            ecrire(`${ptxT("Fichiers")} ${i + 1}/${ok.length}…`);
            const l = ok[i];
            appliquer(l);
            const pf = await P.printFile(s);
            const nom = [slug(l.nom) || 'sans-nom', l.numero, slug(l.taille), slug(P.data.title), slug(couleur), ref].filter(Boolean).join('_');
            props.push([`_${Z}${ptxT(", fichier à imprimer,")} ${String(i + 1).padStart(2, '0')} ${[l.nom, l.numero, l.taille].filter(Boolean).join(' ')}`.trim(), await P.deposerPng(pf.blob, `${nom}.png`)]);
          }
          appliquer(exemple());
        } else {
          const pf = await P.printFile(s);
          emplacements.push(`${Z} : ${pf.wCm.toFixed(1).replace('.', ',')} × ${pf.hCm.toFixed(1).replace('.', ',')} cm, ${String(pf.position).toLowerCase()}`);
          const dims = `${pf.wCm.toFixed(1)}x${pf.hCm.toFixed(1)}cm`.replace(/\./g, ',');
          const resolution = pf.faible ? `${pf.reelle}dpi_RESOLUTION-FAIBLE` : `${pf.dpi}dpi`;
          const nom = [slug(P.data.title), slug(couleur), slug(Z).toLowerCase(), dims, slug(pf.position), resolution, ref].filter(Boolean).join('_');
          props.push([`_${Z}${ptxT(", aperçu")}`, await P.previewFile(s), `apercu_${nom}.jpg`]);
          props.push([`_${Z}${ptxT(", fichier à imprimer")}`, await P.deposerPng(pf.blob, `${nom}.png`)]);
          const ca = P.consigneAtelier?.(s, pf);
          if (ca) props.push([`_${Z}${ptxT(", position")}`, ca.texte]);
        }
      }
      const parTaille = {};
      ok.forEach((l) => { parTaille[l.taille] = (parTaille[l.taille] || 0) + l.qte; });
      const recap = tailles().filter((t) => parTaille[t]).map((t) => (t ? `${t} × ${parTaille[t]}` : `${parTaille[t]}`)).join(', ');
      const noms = ok.filter((l) => l.nom || l.numero).map((l) => `${[l.nom, l.numero].filter(Boolean).join(' ')}${l.taille ? ` (${l.taille}${l.qte > 1 ? ` × ${l.qte}` : ''})` : ''}`);
      const detail = ok.map((l, i) => `${i + 1}. ${l.nom || '—'}${l.numero ? `, n° ${l.numero}` : ''}${l.taille ? `, ${l.taille}` : ''}, ${l.qte}`).join('\n');
      const st = etat.style;
      const fd = new FormData();
      fd.append('id', commande.id);
      fd.append('quantity', 1);
      if (!sansTaille()) fd.append('properties[Tailles]', recap);
      if (couleur) fd.append('properties[Couleur]', couleur);
      if (emplacements.length) fd.append('properties[Emplacements]', emplacements.join(', '));
      // BAT validé en ligne : aperçu de toute l'équipe vu et accepté, horodaté dans la commande.
      fd.append('properties[_BAT]', `aperçu de l'équipe validé en ligne le ${new Date().toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short', timeZone: 'Europe/Paris' }).replace(' ', ' à ')}`);
      if (noms.length) fd.append(`properties[${perso() ? (avecNom() && avecNumero() ? 'Noms et numéros' : avecNom() ? 'Noms' : 'Numéros') : 'Noms'}]`, noms.join(', ').slice(0, 1500));
      props.forEach(([k, v, n]) => (v instanceof Blob ? fd.append(`properties[${k}]`, v, n) : fd.append(`properties[${k}]`, v)));
      fd.append('properties[_Équipe]', detail);
      if (perso()) fd.append('properties[_Équipe style]', `${st.contenu}, ${st.police}, ${couleurTexte()}, taille ${st.taille}, ${JAMBES() ? `${P.SIDES[cote()].toLowerCase()}, ${st.position === 'jambe' ? 'long de la jambe' : 'haut de cuisse'}` : st.position === 'haut' ? 'haut du dos' : 'centre du dos'}`);
      fd.append('properties[_ppx]', [ref, qty, commande.pack, commande.teinte, commande.marquages,
        sansTaille() ? '' : tailles().join(','), Object.entries(parTaille).map(([t, q]) => `${t}:${q}`).join(',')].join('|'));
      fd.append('properties[_equipe]', perso() ? st.contenu : 'oui');
      ecrire(ptxT("Envoi…"));
      await P.postCart(fd);
      history.replaceState(null, '', location.pathname + location.search);
      ecrire(ptxT("✓ Équipe ajoutée au panier"));
      await new Promise((r) => setTimeout(r, 650));
      window.location.href = P.data.cartUrl;
    } catch (e) {
      erreur(`${ptxT("L'ajout au panier a échoué :")} ${e.message}. Réessayez ou appelez-nous au 01 86 04 31 65.`);
      add.disabled = false;
      ecrire(libelle);
      if (btn) btn.textContent = ptxT("Ajouter l'équipe au panier");
      enCours = false;
    }
  }

  /* ---------- Ouverture directe (badge de la fiche, modèle « Nom et numéro » de l'onglet Idées) ---------- */
  function ouvrir() {
    const modal = document.getElementById('PrinttexPerso');
    if (modal?.hidden) document.querySelector('[data-pp-open]')?.click();
    const debut = Date.now();
    (function attendre() {
      if (P && racine && P.state.ready) {
        P.setTab('quantites');
        if (!etat.actif) activer(); else allerA(aDos() ? 'style' : 'liste');
        return;
      }
      if (Date.now() - debut < 10000) setTimeout(attendre, 150);
    }());
  }
  window.PrinttexEquipe = { ouvrir, actif: () => etat.actif };
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-peo-badge]')) return;
    e.preventDefault();
    ouvrir();
  });

  if (window.PrinttexPerso) installer();
  else document.addEventListener('pp:pret', installer);
})();
